import React from 'react';
import AppointmentManagementProvider from '../../lib/context/ManageAppointmentContext';
import { useQuery } from '@tanstack/react-query';
import useApi from '../../hooks/useApi';
import useAppointmentManagementActions from '../../hooks/useAppointmentManagmentActions';
import { ActionDropdown, ActionItem } from '../Table/TableDataView';

type AppointmentActionMenuProps = {
  appointmentId: number;
  extraActions?: ActionItem[];
  refetchFn?: () => void;
};

const AppointmentActionMenu = ({ appointmentId, extraActions, refetchFn }: AppointmentActionMenuProps) => {
  const { Api } = useApi();

  const { data: appointmentDetails, refetch: refetchAppointmentDetails } = useQuery({
    queryKey: ['actionedAppointment', appointmentId],
    queryFn: async () => {
      const response = await Api.booking.getAppointmentList({ appt_id: appointmentId });

      return response?.data?.appointments?.[0] || null;
    },
    enabled: !!appointmentId
  });

  const { generateAppointmentActions } = useAppointmentManagementActions({
    refetchFn: () => {
      refetchFn?.();
      refetchAppointmentDetails();
    }
  });

  if (!appointmentDetails) return null;

  const appointmentActions = generateAppointmentActions(appointmentDetails);

  const mergedActions = extraActions?.length ? [...appointmentActions, ...extraActions] : appointmentActions;

  return (
    <ActionDropdown customDataTestID="timeline-appointment-action-dropdown" actionItems={mergedActions} rowData={{}} />
  );
};

const ActionMenuWithContextProvider = (props: AppointmentActionMenuProps) => {
  return (
    <AppointmentManagementProvider>
      <AppointmentActionMenu {...props} />
    </AppointmentManagementProvider>
  );
};

export default ActionMenuWithContextProvider;
